(window as any)["Ragnarok"] = (window as any)["Ragnarok"] || {};

/* Typings to be exposed to library user */
export { GridApp } from "./output/gridapp";
export * from "./output/interfaces";
export * from "./output/rerrorcode";
export {
    EdgeInsets,
    ChooseStreamingSettings,
    ChooseStreamingResolution,
    InitializeUtils,
    GetSupportedAudioChannelCount
} from "./output/util/utils";
export {
    VideoMode,
    ScaledVideoMode,
    DeviceCapabilities,
    StreamFeatures,
    GetDeviceCapabilities,
    getDeviceCapabilities,
    serializeDeviceCapabilities,
    getSupportedCodecs
} from "./output/util/devicecapabilities";
export { VirtualButton, VirtualGamepad, VirtualGamepadHandler } from "./output/input/virtualgamepad";
export * from "./output/util/settings";
export * from "../gridserver-core/index-output";
export {
    CHANGELIST,
    BrowserName,
    PlatformName,
    DeviceType,
    DeviceOS,
    DeviceModel,
    DeviceVendor,
    getPlatformDetails,
    PlatformDetails,
    LogData,
    LogLevel,
    LogEvent,
    authTokenCallbackType,
    AuthType,
    AuthInfo,
    // Dev client is still relying on these interfaces, so export them intentionally
    performHttpRequest,
    RequestHttpOptions,
    Response,
    AddPlatformTelemetry,
    LogImpl,
    PayloadPlatformDetails,
    ClientHeaderPlatformDetails,
    PayloadOSType,
    PayloadBrowserType,
    PayloadDeviceType,
    ClientHeaderOSType,
    ClientHeaderBrowserType,
    ClientHeaderDeviceType,
    translatePlatformDetailsForPayload,
    translatePlatformDetailsForClientHeader,
    registerLogCallback,
    TelemetryEventPayload,
    Telemetry,
    TelemetryConfiguration,
    TelemetryCommonData
} from "../rtcutils-core/index-output";
export {
    getStreamerType,
    BrowserFeature,
    isFeatureSupported,
    IsFeatureSupported,
    shouldDefaultEnableMic,
    getRecommendedBitrate,
    getStreamStartParameters,
    estimateDataUsage,
    CalculateMaxBitrateKbps,
    CalculateDataUsage,
    NskTelemetry
} from "./output/nskutils";
export * from "./output/nskinterfaces";
